import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ProProvider } from "@/context/ProContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ToolPage from "@/pages/ToolPage";
import FaqPage from "@/pages/FaqPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ContactPage from "@/pages/ContactPage";
import StatusPage from "@/pages/StatusPage";
import FlowPage from "@/pages/FlowPage";
import HistoricoPage from "@/pages/HistoricoPage";
import EquipePage from "@/pages/EquipePage";
import PlansPage from "@/pages/PlansPage";
import ProSuccessPage from "@/pages/ProSuccessPage";
import ProCancelPage from "@/pages/ProCancelPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
    return (
        <div className="bg-[#FAFAF9] text-[#09090B] min-h-screen flex flex-col">
            <BrowserRouter>
                <ProProvider>
                    <Header />
                    <div className="flex-1">
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/ferramentas" element={<CatalogPage />} />
                            <Route path="/fluxo" element={<FlowPage />} />
                            <Route path="/historico" element={<HistoricoPage />} />
                            <Route path="/equipe" element={<EquipePage />} />
                            <Route path="/ferramentas/:slug" element={<ToolPage />} />
                            <Route path="/faq" element={<FaqPage />} />
                            <Route path="/privacidade" element={<PrivacyPage />} />
                            <Route path="/termos" element={<TermsPage />} />
                            <Route path="/contato" element={<ContactPage />} />
                            <Route path="/status" element={<StatusPage />} />
                            <Route path="/planos" element={<PlansPage />} />
                            <Route path="/pro/sucesso" element={<ProSuccessPage />} />
                            <Route path="/pro/cancelado" element={<ProCancelPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </div>
                    <Footer />
                </ProProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
